import {withStyles} from '@material-ui/core/styles'
import React from 'react'
import {TopToolbar, Datagrid, DateField, NumberField,
  Filter, List, SearchInput, TextField, BooleanField} from 'react-admin'
import AccountField from './AccountField'
import PhoneField from '../../custom/common/PhoneField'

const styles = theme => ({
  title: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  hiddenOnSmallScreens: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
})
const Actions = ({basePath,}) => (
  <TopToolbar>
  </TopToolbar>
)

const ListFilter = props => (
  <Filter {...props}>
    <SearchInput placeholder={'전화번호/이름/아이디'} source="search" alwaysOn/>
  </Filter>
)

export default withStyles(styles)(({classes, ...props}) => {
  return (
    <List {...props}
          actions={<Actions/>}
          filters={<ListFilter classes={classes}/>}
          perPage={25}
          bulkActionButtons={false}>
      <Datagrid rowClick="show">
        <TextField source="id"/>
        <TextField source="name" sortable={false}/>
        <AccountField sortable={false}/>
        <PhoneField source="phone" sortable={false}/>
        <PhoneField source="email" sortable={false}/>
        <NumberField source="orderCount"/>
        <NumberField source="orderPrice"/>
        <NumberField source="point"/>'
        <BooleanField source="isDel"/>
        <DateField source="createdAt" locales='ko' showTime/>
      </Datagrid>
    </List>
  )
})

